/**
 * Configuración del proveedor de identidad.
 *
 * REACT_APP_AUTH_PROVIDER = 'Ecolab' | 'Local'
 *
 *   Ecolab → los usuarios viven en Ecolab (proveedor de identidad del
 *            ecosistema Redeprog). El login se hace contra su API y el POS
 *            solo valida el token. Es el modo del ecosistema.
 *
 *   Local  → el POS gestiona sus propios usuarios con ASP.NET Identity.
 *            Es el modo para vender el POS por separado de la red.
 *
 * Tiene que coincidir con Auth:Provider del backend. Si el frontend está en
 * Ecolab y el backend en Local (o al revés), el login falla con 404 o el
 * token no valida.
 */

export type AuthProvider = 'Ecolab' | 'Local';

export const AUTH_PROVIDER: AuthProvider =
  (process.env.REACT_APP_AUTH_PROVIDER as AuthProvider) || 'Local';

export const ES_ECOLAB = AUTH_PROVIDER === 'Ecolab';

/**
 * URL base de la API de Ecolab. Solo se usa en modo Ecolab.
 * El Marketplace usa la misma variable, con el mismo valor.
 */
export const ECOLAB_API_URL =
  process.env.REACT_APP_ECOLAB_API_URL || 'https://ecolab-api.redprosumo.co';

/**
 * Claves de localStorage.
 *
 * NOTA: el POS usa 'token' desde siempre y hay código que lo lee directo,
 * así que se conserva. Las de refresh y usuario son nuevas.
 *
 * El Marketplace usa 'rp_token' / 'rp_refresh' / 'rp_user'. Son deliberadamente
 * distintas: si algún día ambas apps corren en el mismo dominio, compartir
 * clave haría que una pisara la sesión de la otra.
 */
export const STORAGE = {
  TOKEN: 'token',
  REFRESH: 'pos_refresh',
  USER: 'pos_user',
  /** Empresa activa cuando la persona está en varias; va en el header X-Empresa-Id. */
  EMPRESA: 'pos_empresa',
} as const;
